<template>
	<div class="option-group">
		<label class="label">
			{{label}}
		</label>
		<erco-tooltip v-if="tooltip && tooltip.text"
		              :variant="tooltip.variant"
		              :title="tooltip.title"
		              :text="tooltip.text">
		</erco-tooltip>

		<div class="wrap"
		     v-if="chained">
			<b-form-radio v-model="valueChained"
			              :options="options"
			              @change="handleChange"
			              stacked>
			</b-form-radio>
		</div>

		<div class="wrap"
		     v-if="!chained"
		     @click.capture="handleWrapClick">
			<b-form-radio
			              v-for="(option, index) in options"
			              :key="option.value"
			              v-model="value[index]"
						  :options="[option]"
						  @change="handleChange"
						  stacked>
			</b-form-radio>
		</div>
	</div>
</template>
<script>

import ErcoTooltip from '@/components/molecules/ErcoTooltip';

export default {
	name: 'ErcoRadioGroupMolecule',

	props: {
		label: {
			type: String,
			default: '',
		},
		options: {
			type: Array,
			default: [],
		},
		change: {
			type: Function,
			default: () => {},
		},
		chained: {
			type: Boolean,
			default: true,
		},
		freezed: {
			type: Boolean,
			default: false,
		},
		tooltip: {
			type: Object,
			required: false,
			default: () => ({ variant: '', title: '', text: '' }),
		},
	},

	components: {
		ErcoTooltip,
	},

	computed: {
		valueChained() {
			return this.options.reduce((val, option) => (option.selected ? option.value : val), '');
		},
		value() {
			return this.options.map(option => (option.selected ? option.value : ''));
		},
	},

	methods: {
		handleChange(value) {
			if (this.freezed) {
				return;
			}

			this.$emit('change', value);
		},

		handleWrapClick(event) {
			if (this.freezed) {
				event.preventDefault();
			}
		},
	},
};
</script>

<style lang="scss">

	.option-group {
		& > .label {
			display: inline-block;
			margin-bottom: 0.5rem;
		}
	}

</style>



// WEBPACK FOOTER //
// ErcoRadioGroup.vue?5f07b126